import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  profile: {
    _id: "",
    email: "",
    adminAccess: "",
    created_at: "",
  },
  dialogs: {
    openCheckmail: {
      isOpen: false,
      action: "",
      email:""
    },

    openUniversitylist: {
      isOpen: false,
      action: "",
    },

    changeStatus: {
      isOpen: false,
      action: "",
      schoolID:""
    },


    activateDeactivateUser: {
      isOpen: false,
      action: "",
      userId:""
    },

    deleteUniversity: {
      isOpen: false,
      action: "",
      schoolId:""
    },

    changeCityStatus: {
      isOpen: false,
      action: "",
      cityID: "",
    },

    deleteCity: {
      isOpen: false,
      action: "",
      cityID: "",
    },

    changeSubscriptionRequired: {
      isOpen: false,
      action: "",
      schoolID: "",
      cityID: "",
      name: "",
      subscription_required: false,
    },

    logout: {
      isOpen: false,
      action: "",
    },

    collapseSidenav: {
      isCollapse: false,
      action: "",
    },

    toggleSidebar:{
      isOpen:false,
      action:""
    }

  },
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setDialogues: (state, { payload }) => {
      state.dialogs[payload.type] = payload;
    },
    setAuth: (state, { payload }) => {
      state.isAuthenticated = true;
      state.profile = payload;
    },
    logOut: (state, { payload }) => {
      state.isAuthenticated = false;
      state.profile = initialState.profile;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setDialogues, setAuth, logOut } = appSlice.actions;

export default appSlice.reducer;
